import React, { useEffect, useState, useRef, useMemo } from 'react';
import SwiperCore, { Keyboard, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getSimilarProducts } from '@utils/product';
import ProductTile from '@moncler/components/listing/ProductTile';
import { useTranslation } from 'react-i18next';
SwiperCore.use([Keyboard, Navigation]);
const SimilarProductCarousel = (props) => {
    const { t } = useTranslation();
    const carouselWrapper = useRef();
    const swiperRef = useRef();
    const [similarProductsTiles, setSimilarProductsTiles] = useState(props.similarProductsTiles);
    const shouldEnabledCarousel = (similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) > 2;
    const [visibleSlidesIndexes, setVisibleSlidesIndexes] = useState([]);
    const [carouselEnabled, setCarouselEnabled] = useState();
    useEffect(() => {
        var _a;
        (_a = carouselWrapper.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (!props.similarProductsTiles) {
            getSimilarProducts(props.product).then((data) => setSimilarProductsTiles(data));
        }
    }, []);
    const carouselArrows = useMemo(() => {
        if (shouldEnabledCarousel) {
            return (React.createElement("div", { className: "similar-product-carousel--controllers-arrows" },
                React.createElement("button", { className: "swiper-button-prev", "aria-label": t('carousel.prevslidemessage') },
                    React.createElement("span", { className: "icon--arrow-left" })),
                React.createElement("button", { className: "swiper-button-next", "aria-label": t('carousel.nextslidemessage') },
                    React.createElement("span", { className: "icon--arrow-right" }))));
        }
        else {
            React.createElement(React.Fragment, null);
        }
    }, [shouldEnabledCarousel]);
    if (!similarProductsTiles || (similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "similar-product-container", ref: carouselWrapper },
            React.createElement("div", { className: `similar-product-carousel ${shouldEnabledCarousel ? 'carousel-enabled' : ''}`, "aria-label": t('similarproduct.modaltitlea11y'), tabIndex: -1 },
                React.createElement("div", { className: `similar-product-carousel--controllers${props.labelVisible ? '-label-visible' : ''}` },
                    props.labelVisible && React.createElement("span", { className: "similar-product-carousel--controllers-label" }, t('similarproduct.label')),
                    React.createElement("div", { className: "similar-product-carousel--arrow-container" },
                        carouselArrows,
                        props.floatingModule && (React.createElement("button", { className: "button close", "aria-label": t('button.close'), onClick: () => {
                                props.setShowFloatingModal(false);
                                props.setExpanded(false);
                            } },
                            React.createElement("i", { className: "icon--close" }))))),
                React.createElement(Swiper, Object.assign({ onSwiper: (swiper) => {
                        swiperRef.current = swiper;
                        // focus on fully visible slides
                        setVisibleSlidesIndexes([swiper.realIndex, swiper.realIndex + 1]);
                        setCarouselEnabled(swiper.enabled);
                    }, className: 'similar-product-carousel--cards-wrapper', keyboard: true, wrapperTag: "ul", navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled',
                    }, slidesPerView: "auto", a11y: {
                        slideRole: 'listitem',
                    }, spaceBetween: 4, onSlideChange: (swiper) => {
                        //@ts-ignore disable-next-line
                        setVisibleSlidesIndexes([swiper.realIndex, swiper.realIndex + 1]);
                    }, watchSlidesProgress: true, enabled: shouldEnabledCarousel, breakpoints: {
                        1024: {
                            slidesPerView: 2,
                        },
                    } }, props.swiperConf), similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.slice(0, 10).map((sp, i) => (React.createElement(SwiperSlide, { className: "similar-product-slide", onClick: (e) => {
                        props.onRequestClose(e);
                    }, key: sp.uuid, tag: "li", "tab-index": carouselEnabled && (visibleSlidesIndexes === null || visibleSlidesIndexes === void 0 ? void 0 : visibleSlidesIndexes.includes(i)) ? 0 : -1, "aria-hidden": carouselEnabled && !(visibleSlidesIndexes === null || visibleSlidesIndexes === void 0 ? void 0 : visibleSlidesIndexes.includes(i)) },
                    React.createElement(ProductTile, { product: sp, actionList: 'pdp', type: "RECS", disableQuickShop: true, noRollover: true, noSwatch: true, disableFocus: carouselEnabled && !(visibleSlidesIndexes === null || visibleSlidesIndexes === void 0 ? void 0 : visibleSlidesIndexes.includes(i)) })))))))));
};
export default SimilarProductCarousel;
